import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import useSuperSearchDropdownContext from 'NewComponents/FormComponents/SuperSearchDropdown/useSuperSearchDropdownContext';
import NoDataFound from 'Common/NoDataFound';

const PatientSuperSearchTemplate = ({ handleSelectedData, identifier, height = '100%', width = '100%' }) => {
  const { state, onSetSelectedRowNumber, onSetSearchStatus, onSetInputValue, onToggleDropDown, onSetData } = useSuperSearchDropdownContext();
  const { data, selectedRowNumber } = state;

  const handleSingleRow = (singlerow, index) => {
    onSetSelectedRowNumber(index);
    handleSelectedData(singlerow);
    onSetSearchStatus(false);
    onSetInputValue('');
    onToggleDropDown(false);
    onSetData([]);
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.05,
        delayChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: {
      opacity: 0,
      y: -10,
      scale: 0.95,
    },
    visible: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        type: 'spring',
        stiffness: 300,
        damping: 24,
      },
    },
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -10 }}
      transition={{ duration: 0.2, ease: 'easeOut' }}
      style={{ height: data.length > 0 ? 'auto' : '100%', width: width, minHeight: '10px', maxHeight: '300px', overflow: 'auto' }}
      className='p-2 mt-1 bg-white border border-gray-200 rounded-md shadow-xl shadow-gray-200/50 backdrop-blur-sm dark:border-gray-700/60 dark:bg-gray-900/95 dark:shadow-gray-900/50'
    >
      {data.length > 0 ? (
        <motion.div variants={containerVariants} initial='hidden' animate='visible' className='space-y-2'>
          <AnimatePresence mode='wait'>
            {data.map((pat, index) => {
              const isSelected = index === selectedRowNumber;

              return (
                <motion.div
                  key={pat.id}
                  id={`${identifier}_${index}`}
                  variants={itemVariants}
                  initial='hidden'
                  animate='visible'
                  whileHover='hover'
                  whileTap={{ scale: 0.98 }}
                  onClick={() => handleSingleRow(pat, index)}
                  className='relative overflow-hidden rounded-lg cursor-pointer'
                >
                  <motion.div
                    className={`relative flex items-center group gap-3 hover:bg-[#F3F4F7] rounded-lg px-3 py-1 transition-all duration-300 ${isSelected
                      ? 'bg-[#F3F4F7] '
                      : ''
                      }`}
                  >
                    {/* Animated background gradient on hover */}
                    {/* {isSelected ? null : (
                      <motion.div
                        className='absolute inset-0 rounded-lg bg-gradient-to-r from-primary/10 via-primary/5 to-primary/10 dark:from-primary/20 dark:via-primary/10 dark:to-primary/20'
                        initial={{ opacity: 0 }}
                        whileHover={{ opacity: 1 }}
                        transition={{ duration: 0.2, ease: 'easeOut' }}
                      />
                    )} */}



                    {/* Patient info */}
                    <div className='relative flex-1 min-w-0 z-base'>
                      <motion.div
                        title={pat.name}
                        className='text-sm font-semibold text-gray-900 truncate transition-all duration-300  dark:text-gray-100'
                        transition={{ duration: 0.2 }}
                      >
                        {pat.name}
                      </motion.div>
                      <motion.div
                        className='mt-0.5 truncate text-xs font-medium text-gray-600 dark:text-gray-400 transition-all duration-300'
                        transition={{ duration: 0.2 }}
                      >
                        <span className='font-mono'>Account #: {pat.accountNum}</span>
                      </motion.div>
                    </div>



                    {/* Hover glow effect */}
                    {/* {isSelected ? null : (
                      <motion.div
                        className='absolute inset-0 rounded-lg bg-gradient-to-r from-primary/0 via-primary/10 to-primary/0 dark:via-primary/20'
                        initial={{ opacity: 0 }}
                        whileHover={{ opacity: 1 }}
                        transition={{ duration: 0.2, ease: 'easeOut' }}
                      />
                    )} */}
                  </motion.div>
                </motion.div>
              );
            })}
          </AnimatePresence>
        </motion.div>
      ) : (
        <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.3 }}>
          <NoDataFound />
        </motion.div>
      )}
    </motion.div>
  );
};

export default PatientSuperSearchTemplate;
